/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Activity_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "Plan, storage, and copilot changes will appear here." |
*
* @param {Partner_Activity_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_activity_empty_body = /** @type {((inputs?: Partner_Activity_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Activity_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tarif-, Speicher- und Copilot-Änderungen erscheinen hier.")
	return /** @type {LocalizedString} */ ("Plan, storage, and copilot changes will appear here.")
});